import Avatar1x from "../components/core/Avatar/assets/avatar-light_1x.webp";
import Avatar2x from "../components/core/Avatar/assets/avatar-light_2x.webp";
import Avatar3x from "../components/core/Avatar/assets/avatar-light_3x.webp";

export type LeaderboardType = "daily" | "weekly" | "monthly";
export type IAvatarSize = "xs" | "s" | "m" | "l" | "xl";
export const DefaultProfileSrcSet = `${Avatar1x} 1x, ${Avatar2x} 2x, ${Avatar3x} 3x`;

export const AvatarSizeMapping = {
  xs: 32,
  s: 40,
  m: 60,
  l: 80,
  xl: 100,
};

export const FireIconSizeMapping = {
  xs: 12,
  s: 16,
  m: 24,
  l: 40,
  xl: 40,
};
